export function isEmail(str) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(str);
}

export function isPostcode(str) {
  const re = /^[A-Za-z]{1,2}[0-9][0-9A-Za-z]? ?[0-9][A-BD-HJLNP-UW-Za-bd-hjlnp-uw-z]{2}$/i;
  return re.test(str);
}

export function stringContainsSpaces(str) {
  const re = /\s/;
  return re.test(str);
}

// Password to have minimum of 8 digits with at least one number, maximum of 50 characters.
export function isPassword(str) {
  const re = /^(?=.*[a-z]|[A-Z])(?=.*\d).{8,50}$/;
  return re.test(str);
}

export function containsNumbers(str) {
  const re = /\d/;
  return re.test(str);
}

export function isNumber(str) {
  const re = /^[0-9]*$/;
  return re.test(str);
}

export function isPhoneNumber(str) {
  const re = /^[0-9\(\)\+\-.\s]*$/;
  return re.test(str);
}

export function isMemberNumber(str) {
  const re = /^(?=.*\d).{6,8}$/;
  return re.test(str);
}

export function isBankAccountNumber(str) {
  const re = /^(?=.*\d).{7,8}$/;
  return re.test(str);
}

export function isBankSortCode(str) {
  const re = /\d\d\d\d\d\d/;
  return re.test(str);
}

export function isFirstLetterUppercase(str) {
  const re = /^[A-Z][a-z]*$/;
  return re.test(str);
}

export function leaveNumbers(str) {
  return str.replace(/\D/g, '');
}

export function leaveFloat(str) {
  return str.replace(/[^\d.-]/g, '');
}

export function splitString(str) {
  return str.match(/[\W]*[a-z|0-9]+[\W]?/gi);
}

export function leaveWords(str) {
  return str.match(/(\w*[a-z]\w*)/);
}

